export const categories = [
  { slug: 'mingxing-chouwen', name: '明星丑闻', icon: 'ri-alert-line', description: '明星艺人负面新闻与争议事件全收录' },
  { slug: 'lianqing-baoguang', name: '恋情曝光', icon: 'ri-heart-line', description: '娱乐圈最全恋情动态，地下情、隐婚、分手内幕' },
  { slug: 'quannei-miwen', name: '圈内秘闻', icon: 'ri-eye-off-line', description: '不为人知的娱乐圈潜规则与行业内幕' },
  { slug: 'zongyi-xianchang', name: '综艺现场', icon: 'ri-live-line', description: '综艺录制现场一手爆料与幕后故事' },
  { slug: 'yingshi-neimu', name: '影视内幕', icon: 'ri-film-line', description: '影视剧投资、选角、片酬等业内深度爆料' },
];

export const articles = [
  {
    id: 'ding-liu-si-hui',
    slug: 'ding-liu-si-hui',
    title: '某顶流男星深夜私会女网红，酒店共处8小时被拍',
    excerpt: '据知情人士透露，该顶流男星近日在横店拍戏期间，深夜与一名疑似网红的女子在酒店共处长达8小时...',
    content: `<p>近日，一条重磅爆料在娱乐圈炸开了锅。某顶流男星在横店拍摄新剧期间，被拍到深夜与一名神秘女子前后脚进入某五星级酒店，据蹲守记者描述，两人在酒店内共处时间长达8小时之久。</p><p>据知情人士透露，这名男星目前正处于事业上升期，手上有三部待播剧和多档综艺合约，此前一直以单身形象示人。而与其共处酒店的女子被网友扒出疑似某平台百万粉丝网红，两人此前曾在社交平台有过互动。</p><p>更让人浮想联翩的是，第二天清晨该女子独自离开酒店时，刻意用口罩和帽子遮挡面部，行色匆匆。而男星则在两小时后才离开酒店前往片场。</p><p>目前该男星的工作室尚未对此事做出回应。但事件已在粉丝群体中引发轩然大波，不少粉丝表示"塌房了"，也有理性的声音认为这可能是正常社交行为。</p><p>本报将持续关注此事进展。</p>`,
    category: 'mingxing-chouwen',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20paparazzi%20shot%20of%20a%20male%20celebrity%20walking%20into%20a%20luxury%20hotel%20at%20night%2C%20dark%20moody%20atmosphere%2C%20red%20carpet%2C%20neon%20lights%2C%20cinematic%20style%2C%20mysterious%20and%20intense%20vibe%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20amber%20and%20crimson%20tones&width=800&height=450&seq=article-cover-01&orientation=landscape',
    author: '黑料小编',
    publishedAt: '2026-08-07T10:30:00',
    tags: ['顶流男星', '私会', '酒店', '塌房'],
    isHot: true,
    isNew: true,
    viewCount: 1280000,
    commentCount: 5600,
  },
  {
    id: 'nv-tuan-jie-san',
    slug: 'nv-tuan-jie-san',
    title: '爆火女团内部不和实锤？队长被曝私下排挤成员',
    excerpt: '该女团近期活动频繁，但内部矛盾似乎已经到了不可调和的地步。有工作人员向本报提供了独家细节...',
    content: `<p>近日，一支出道仅两年便迅速走红的女团被曝出内部不和。据多位节目组工作人员爆料，该女团队长在私下对部分成员态度恶劣，甚至故意在彩排时忽略队友的配合需求。</p><p>一位不愿透露姓名的工作人员告诉记者："队长在镜头前表现得非常照顾队友，但镜头一关，整个人就变了。有好几次彩排，她明明看到队友需要帮助，却装作没看见。"</p><p>更令人震惊的是，有知情人士透露，队长曾私下向公司高层施压，要求调整部分成员的演出站位和歌词分配，导致团内氛围愈发紧张。</p><p>目前该女团经纪公司发布声明称"成员之间关系融洽，不存在任何矛盾"，但多位业内人士表示，该团解散似乎只是时间问题。</p>`,
    category: 'mingxing-chouwen',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20girl%20group%20on%20stage%20with%20tension%20between%20members%2C%20one%20standing%20apart%20looking%20cold%2C%20dramatic%20stage%20lighting%2C%20backstage%20atmosphere%2C%20K-pop%20style%20outfits%2C%20emotional%20conflict%2C%20cinematic%20wide%20shot%2C%20dark%20background%20with%20spotlights&width=800&height=450&seq=article-cover-02&orientation=landscape',
    author: '吃瓜一线',
    publishedAt: '2026-08-07T08:15:00',
    tags: ['女团', '内部不和', '排挤', '解散'],
    isHot: true,
    isNew: true,
    viewCount: 960000,
    commentCount: 4200,
  },
  {
    id: 'yingdi-hunyin',
    slug: 'yingdi-hunyin',
    title: '影帝婚姻亮红灯？妻子社交平台删除所有合照',
    excerpt: '有细心的网友发现，影帝的妻子在社交平台上悄然删除了所有与丈夫的合影，引发婚变猜测...',
    content: `<p>近日，有细心的网友发现，某位多次获得影帝殊荣的男演员的妻子，在社交平台上悄无声息地删除了所有与丈夫的合影，这一举动立刻引发了全网关于两人婚姻状况的热议。</p><p>这对夫妻一直是娱乐圈公认的模范夫妻，结婚十余年来从未传出过任何绯闻。然而从今年年初开始，两人就很少在公开场合同框出现，社交媒体上的互动也明显减少。</p><p>有媒体尝试联系双方经纪人求证，但均未得到正面回应。影帝工作室仅表示"艺人的私人生活不便过多讨论"。</p><p>值得一提的是，影帝近期正在国外拍摄一部大片，而妻子则留在国内带孩子。长时间的两地分居是否成为了婚姻危机的导火索？</p>`,
    category: 'mingxing-chouwen',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20lonely%20woman%20looking%20at%20her%20phone%20in%20a%20luxurious%20living%20room%2C%20evening%20light%20through%20curtain%2C%20emotional%20and%20melancholic%20atmosphere%2C%20soft%20focus%2C%20cinematic%20style%2C%20warm%20interior%20lighting%2C%20contemplative%20mood&width=800&height=450&seq=article-cover-03&orientation=landscape',
    author: '黑料小编',
    publishedAt: '2026-08-06T20:00:00',
    tags: ['影帝', '婚姻危机', '删合照', '婚变'],
    isHot: true,
    isNew: false,
    viewCount: 890000,
    commentCount: 3800,
  },
  {
    id: 'xin-ren-lian-qing',
    slug: 'xin-ren-lian-qing',
    title: '新晋小花与富二代男友甜蜜约会，疑似好事将近',
    excerpt: '新晋小花旦近日被拍到与富二代男友在某高级餐厅共进晚餐，两人举止亲密，甜蜜互动不断...',
    content: `<p>今年凭借一部古装剧爆红的新晋小花旦，近日被拍到与从事金融行业的富二代男友在某高级餐厅共进晚餐。两人席间互动甜蜜，男方更是多次为女友夹菜，十分体贴。</p><p>据餐厅其他客人透露，两人用餐近三个小时，期间一直有说有笑，完全没有避讳周围人的目光。结束后男方还贴心地为女友披上外套，两人十指相扣离开餐厅。</p><p>有知情人士透露，两人已经交往超过一年，感情非常稳定，双方家长也已经见过面。"好事将近的可能性很大，听说男方已经在准备求婚了。"</p><p>该小花旦此前在接受采访时曾表示，自己希望在30岁之前完成人生大事，看来这个愿望可能很快就会实现。</p>`,
    category: 'lianqing-baoguang',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20couple%20having%20a%20romantic%20dinner%20at%20a%20high-end%20restaurant%2C%20candlelight%2C%20wine%20glasses%2C%20elegant%20setting%2C%20soft%20warm%20lighting%2C%20intimate%20atmosphere%2C%20lifestyle%20photography%20style%2C%20shallow%20depth%20of%20field&width=800&height=450&seq=article-cover-04&orientation=landscape',
    author: '吃瓜一线',
    publishedAt: '2026-08-06T16:45:00',
    tags: ['小花旦', '富二代', '恋情', '约会'],
    isHot: false,
    isNew: true,
    viewCount: 720000,
    commentCount: 3100,
  },
  {
    id: 'daoyan-qian-guize',
    slug: 'daoyan-qian-guize',
    title: '知名导演被曝潜规则新人，多位女演员实名举报',
    excerpt: '一位在圈内颇具影响力的导演被多位女演员联合实名举报，指控其利用选角权进行不当行为...',
    content: `<p>娱乐圈再爆惊天丑闻。一位在电影圈具有举足轻重地位的知名导演，近日被多位女演员联合实名举报，指控其在选角过程中存在不当行为。</p><p>据其中一位举报者描述，该导演在试镜过程中多次提出不合理要求，并以角色为筹码施压。"他说如果不按他的要求来，这个角色就会给别人。"</p><p>目前已有至少五位女演员加入举报行列，她们的描述高度一致，都指向了该导演长期以来的不当行为模式。</p><p>此事曝光后在业内引发强烈震动。多家与该导演有合作关系的影视公司已紧急发布声明，表示将暂停与该导演的合作，并配合相关调查。</p>`,
    category: 'quannei-miwen',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20film%20set%20with%20a%20director%20chair%20in%20the%20center%2C%20dramatic%20spotlight%2C%20empty%20audition%20room%2C%20ominous%20atmosphere%2C%20shadowy%20figure%20in%20background%2C%20cinematic%20noir%20style%2C%20high%20contrast%20black%20and%20red%20tones&width=800&height=450&seq=article-cover-05&orientation=landscape',
    author: '爆料君',
    publishedAt: '2026-08-06T12:00:00',
    tags: ['导演', '潜规则', '实名举报', '选角'],
    isHot: true,
    isNew: true,
    viewCount: 1560000,
    commentCount: 8900,
  },
  {
    id: 'bianju-chao-xi',
    slug: 'bianju-chao-xi',
    title: '热播剧编剧被曝抄袭？多部作品雷同细节曝光',
    excerpt: '一位曾创作过多部爆款剧的知名编剧，被网友扒出其多部作品存在大量相似情节和台词...',
    content: `<p>近日，豆瓣网友发布了一篇万字长文，详细对比了某知名编剧近年来的多部热播剧，指出其中的大量雷同之处。</p><p>根据该网友的整理，这些作品在人物设定、情节走向、甚至台词方面都存在惊人的相似之处。"同一个编剧的作品有一定风格延续可以理解，但连桥段和台词都几乎一模一样，这就不是风格问题了。"</p><p>该事件发酵后，更多编剧圈内人士站出来发声，透露该编剧长期以来存在"抄袭式创作"的问题，但由于其在业内地位较高，一直无人敢公开指出来。</p><p>目前该编剧尚未对此事做出回应，但其最新作品的口碑已经开始受到影响。</p>`,
    category: 'yingshi-neimu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20writer%20desk%20with%20scattered%20scripts%20and%20notes%2C%20dim%20lighting%2C%20creative%20chaos%2C%20red%20pen%20marks%20on%20papers%2C%20dramatic%20shadows%2C%20tense%20atmosphere%2C%20editorial%20style%2C%20warm%20desk%20lamp%20glow&width=800&height=450&seq=article-cover-06&orientation=landscape',
    author: '爆料君',
    publishedAt: '2026-08-05T22:30:00',
    tags: ['编剧', '抄袭', '热播剧', '雷同'],
    isHot: false,
    isNew: true,
    viewCount: 650000,
    commentCount: 2800,
  },
  {
    id: 'zongyi-jianiu',
    slug: 'zongyi-jianiu',
    title: '综艺录制现场爆冲突！两位导师因选手去留当场翻脸',
    excerpt: '在某热门选秀综艺的最新一期录制中，两位导师因为对一位选手的评判产生了严重分歧...',
    content: `<p>据参加某热门选秀综艺录制的现场观众爆料，在最新一期的录制中，两位导师因为对一位选手的去留问题产生了严重分歧，甚至在录制现场当场翻脸。</p><p>"当时气氛超级尴尬，"一位现场观众回忆道，"A导师认为该选手没有进步空间，建议直接淘汰，但B导师坚持认为选手很有潜力，只是需要更多时间。两人你来我往，说话越来越冲。"</p><p>据称，这场争执持续了近二十分钟，最终在导演组的介入下才得以平息。节目组不得不暂停录制，让两位导师各自冷静了半小时后才继续。</p><p>这一片段是否会在正片中播出目前尚不确定，但这期节目的收视率恐怕要爆了。</p>`,
    category: 'zongyi-xianchang',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20talent%20show%20stage%20with%20two%20judges%20arguing%20face%20to%20face%2C%20dramatic%20stage%20lighting%2C%20tension%20in%20the%20air%2C%20contestant%20standing%20nervously%20nearby%2C%20TV%20studio%20atmosphere%2C%20red%20and%20blue%20spotlights%2C%20cinematic%20wide%20shot&width=800&height=450&seq=article-cover-07&orientation=landscape',
    author: '现场观众',
    publishedAt: '2026-08-05T18:00:00',
    tags: ['综艺', '冲突', '导师', '翻脸'],
    isHot: true,
    isNew: false,
    viewCount: 1120000,
    commentCount: 6700,
  },
  {
    id: 'yinyue-jie-fenshou',
    slug: 'yinyue-jie-fenshou',
    title: '乐坛金童玉女分手内幕：性格不合还是第三者介入？',
    excerpt: '曾被誉为乐坛金童玉女的这对歌手情侣突然宣布分手，但背后的原因远不止"性格不合"那么简单...',
    content: `<p>上周，被乐迷们称为"金童玉女"的这对歌手情侣突然在社交平台发布联合声明宣布分手，让无数粉丝心碎。声明中称分手原因是"性格不合"，但多方消息显示，事情远没有那么简单。</p><p>据圈内人士透露，两人分手前一个月关系就已经出现裂痕。导火索是女方发现男方与合作女歌手的关系过于亲密，"不止一次被发现在录音棚待到深夜，还一起外出吃饭"。</p><p>此外，两人在事业规划上也存在严重分歧。女方希望尽快组建家庭，而男方则认为目前是事业上升期，不想被家庭束缚。</p><p>目前两人已经互相取关了社交账号，看来这次是真的结束了。</p>`,
    category: 'lianqing-baoguang',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20microphones%20facing%20away%20from%20each%20other%20on%20a%20dark%20stage%2C%20dramatic%20spotlight%20separating%20them%2C%20emotional%20symbolism%20of%20breakup%2C%20music%20studio%20atmosphere%2C%20warm%20and%20cold%20lighting%20contrast%2C%20cinematic%20composition&width=800&height=450&seq=article-cover-08&orientation=landscape',
    author: '黑料小编',
    publishedAt: '2026-08-05T14:00:00',
    tags: ['歌手', '分手', '金童玉女', '第三者'],
    isHot: false,
    isNew: false,
    viewCount: 580000,
    commentCount: 2400,
  },
  {
    id: 'pian-chou-nei-mu',
    slug: 'pian-chou-nei-mu',
    title: '一线明星片酬大揭秘！有人一集拿千万有人零片酬也要演',
    excerpt: '本报独家获得了一份业内人士提供的片酬清单，揭开了娱乐圈一线明星的真实收入...',
    content: `<p>明星片酬一直是外界津津乐道的话题。近日，本报从多位业内人士处获得了一份相对准确的片酬清单，揭示了当前娱乐圈一线明星的真实收入水平。</p><p>根据这份清单，目前电视剧领域片酬最高的几位演员，单集片酬已经突破千万元大关。而电影方面，头部演员的片酬更是高达数千万甚至上亿。</p><p>但并非所有明星都能拿到高片酬。一些处于上升期或转型期的演员，为了争取好的角色和班底，甚至会选择零片酬出演。"对于他们来说，好作品带来的口碑和后续商业价值，远比眼前的片酬重要。"</p><p>值得一提的是，近年来行业整顿力度加大，"限薪令"的出台使得天价片酬现象得到了一定程度的遏制，但仍有不少演员通过其他方式获得高额报酬。</p>`,
    category: 'yingshi-neimu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stack%20of%20money%20on%20a%20film%20clapperboard%2C%20dramatic%20lighting%2C%20luxurious%20setting%2C%20Hollywood%20vibe%2C%20gold%20and%20black%20color%20scheme%2C%20wealth%20and%20cinema%20theme%2C%20editorial%20product%20photography%2C%20rich%20textures&width=800&height=450&seq=article-cover-09&orientation=landscape',
    author: '爆料君',
    publishedAt: '2026-08-04T20:30:00',
    tags: ['片酬', '一线明星', '零片酬', '限薪令'],
    isHot: false,
    isNew: false,
    viewCount: 750000,
    commentCount: 3500,
  },
  {
    id: 'tong-xing-lian-baoguang',
    slug: 'tong-xing-lian-baoguang',
    title: '当红小生被拍到与同性友人同居？经纪人紧急辟谣',
    excerpt: '近日有媒体拍到一位当红小生频繁出入某高档小区，与其同住的竟然是一位男性友人...',
    content: `<p>近日，某娱乐媒体拍到一位正处于事业巅峰期的当红小生频繁出入某高档小区。更引人注意的是，与其同住的竟然是一位男性友人，两人不仅同进同出，还一起遛狗、购物，关系十分密切。</p><p>这一消息迅速在网络上引发热议。有网友扒出该小生此前在采访中从未公开过恋情，对于感情问题一直避而不谈，这让不少人对他的性取向产生了猜测。</p><p>面对铺天盖地的猜测，该小生的经纪人紧急发布声明辟谣，称两人只是"多年的好朋友"和"室友关系"，因为该友人来京工作暂住其家中。</p><p>然而这个解释似乎并没有让所有人信服，关于两人真实关系的讨论仍在继续。</p>`,
    category: 'quannei-miwen',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20male%20silhouettes%20walking%20together%20at%20sunset%20in%20a%20modern%20city%2C%20luxury%20apartment%20building%20in%20background%2C%20warm%20golden%20hour%20light%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20candid%20shot%2C%20cinematic%20and%20emotional&width=800&height=450&seq=article-cover-10&orientation=landscape',
    author: '吃瓜一线',
    publishedAt: '2026-08-04T16:00:00',
    tags: ['当红小生', '同居', '同性', '辟谣'],
    isHot: false,
    isNew: true,
    viewCount: 980000,
    commentCount: 5200,
  },
  {
    id: 'zongyi-juben',
    slug: 'zongyi-juben',
    title: '综艺也有剧本？前PD揭露真人秀造假产业链',
    excerpt: '一位曾在多家卫视担任过综艺PD的业内人士，近日在社交平台发文揭露真人秀背后的造假产业链...',
    content: `<p>"你们看到的每一个精彩瞬间，都是编剧团队提前设计好的。"一位曾在多家卫视担任过综艺PD（节目导演）的业内人士，近日在社交平台发表长文，大胆揭露了真人秀综艺背后的完整造假产业链。</p><p>据该PD透露，一档典型的真人秀综艺，其"剧本"厚度不亚于一部长篇电视剧。从人设定位、CP配对、冲突制造到感人场景，几乎每一个环节都经过了精心设计。</p><p>"比如大家很喜欢的那对'欢喜冤家'，其实私下关系非常好，但在节目组的要求下必须演出一副水火不容的样子。"该PD举例道。</p><p>他还爆料称，一些节目中出现的"突发状况"，其实是节目组为了制造话题而故意设计的。"真正的突发状况，基本都会被剪掉。"</p>`,
    category: 'zongyi-xianchang',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20TV%20production%20control%20room%20with%20multiple%20screens%2C%20director%20chair%2C%20script%20papers%20scattered%2C%20dark%20room%20illuminated%20by%20monitors%2C%20behind%20the%20scenes%20atmosphere%2C%20cinematic%20documentary%20style%2C%20warm%20monitor%20glow&width=800&height=450&seq=article-cover-11&orientation=landscape',
    author: '前PD爆料',
    publishedAt: '2026-08-03T21:00:00',
    tags: ['综艺', '剧本', '真人秀', '造假'],
    isHot: true,
    isNew: false,
    viewCount: 1350000,
    commentCount: 7800,
  },
  {
    id: 'nv-xing-zheng-he',
    slug: 'nv-xing-zheng-he',
    title: '两大顶流女星资源争夺战白热化，品牌方左右为难',
    excerpt: '两位同为顶流的女明星近期在多个品牌代言和影视资源上展开激烈争夺...',
    content: `<p>娱乐圈的资源争夺从来都不缺少看点。近期，两位同为顶流级别的女明星在多个领域的资源争夺已经进入白热化阶段。</p><p>据知情人士透露，两人从去年开始就一直在暗中较劲。从高奢品牌代言到大制作影视项目，只要有一个人拿到的资源，另一个就一定会去争取类似的甚至更好的。</p><p>"品牌方其实也很为难，"一位公关行业人士表示，"两人的粉丝基础都很强大，商业价值不相上下，选谁都会得罪另一边的粉丝。"</p><p>有趣的是，两位女星在外界面前从未正面回应过这些传闻，但她们的工作室团队之间的暗战早已是公开的秘密。</p>`,
    category: 'quannei-miwen',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20elegant%20female%20silhouettes%20facing%20each%20other%20with%20spotlights%20behind%2C%20luxury%20brand%20atmosphere%2C%20competitive%20tension%2C%20gold%20and%20black%20aesthetic%2C%20fashion%20editorial%20style%2C%20dramatic%20composition%2C%20high-end%20photography&width=800&height=450&seq=article-cover-12&orientation=landscape',
    author: '黑料小编',
    publishedAt: '2026-08-03T15:00:00',
    tags: ['顶流', '女星', '资源争夺', '代言'],
    isHot: false,
    isNew: false,
    viewCount: 630000,
    commentCount: 2900,
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug) || null;
};

export const getHotArticles = () => {
  return articles.filter((a) => a.isHot);
};

export const getNewArticles = () => {
  return articles.filter((a) => a.isNew);
};

export const getRelatedArticles = (currentSlug: string, categorySlug: string, count: number = 3) => {
  return articles
    .filter((a) => a.category === categorySlug && a.slug !== currentSlug)
    .slice(0, count);
};